export default __webpack_public_path__ + "static/media/line-v-06.be5d4c14.png";